var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCirclesThree = function SvgIconCirclesThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.375a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M12 3.625a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5M12.875 16.125a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m4.75-2.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5M6.375 11.375a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5m-2.75 4.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0"
  }))));
};
export default SvgIconCirclesThree;